var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 856,
    viewBox: "0 0 1440 856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -69,
    y: -192,
    width: 1682,
    height: 1048
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-69 814L-6 -1.5L-45 -89.5L1497.5 -192C1570.83 93.6667 1724.2 535.693 1478 433C1203.5 318.5 855.5 351.5 687 621C465.494 975.278 119.667 826.167 -69 814Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1756.41,
    height: 1249,
    transform: "translate(-118 -97)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.365 -107.368H-129.588L-178.377 172.56L1259.68 587.267C1404.22 493.348 1655.85 313.438 1506.07 345.151C1356.28 376.864 730.523 56.6855 436.365 -107.368Z",
    fill: "#F44E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149.713 500.695V-50.6504C141.953 267.206 1177.03 349.604 1658.11 351.071L1836 1294.71L891.86 1056.44L-149.713 500.695Z",
    fill: "#554DDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45624 1591.14L-168.223 448.256C-124.855 302.168 648.572 145.308 1259.86 639.418C1871.14 1133.53 2299.91 1168.3 2740.18 1166.61L9.45624 1591.14Z",
    fill: "#F44E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-200 1274.55V666.743C-158.529 594.385 342.168 575.37 677.593 881.294C1013.02 1187.22 1278.72 1239.89 1555.19 1274.55H-200Z",
    fill: "#16194F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.59 -57.8849L526.382 -190.467L413.373 70.2413L1714.26 810.293C1876.78 752.847 2163.55 636.891 2010.51 632.633C1857.47 628.375 1324.13 170.514 1076.59 -57.8849Z",
    fill: "#4EF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.41 364.057V-98.8296C1105.18 -261.053 116.553 -488.166 427.827 -98.8296C739.101 290.507 1364.58 371.985 1638.41 364.057Z",
    fill: "#0B31B6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: -348,
    y: -327,
    width: 2216.41,
    height: 1709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 115,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1756.41,
    height: 1249,
    fill: "white",
    transform: "translate(-118 -97)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.b734ddb3fe30a710421a66cee2eb7737.svg";
export { ForwardRef as ReactComponent };